import { TPAComponentProps } from '../../types';

export enum CalendarPopoverSides {
  Right = 'right',
  Left = 'left',
}

export interface CalendarPopoverProps extends TPAComponentProps {
  children?: React.ReactNode;
  title?: React.ReactNode;
  onClose(): void;
  withArrow?: boolean;
  arrowSide?: CalendarPopoverSides;
  arrowTop?: number;
  withShadow?: boolean;
  isShown?: boolean;
  animated?: boolean;
  manualFocus?: boolean;
  closeAriaLabel: string;
}

export interface CalendarPopoverDefaultProps {
  title: string;
  withArrow: boolean;
  arrowSide?: CalendarPopoverSides;
  arrowTop: number;
  withShadow: boolean;
  isShown: boolean;
  animated: boolean;
  manualFocus: boolean;
}

export enum CalendarPopoverDataKeys {
  WithShadow = 'data-shadow',
  WithArrow = 'data-arrow',
  Title = 'data-title',
  ArrowTop = 'data-arrow-top',
  Animated = 'data-animated',
  Shown = 'data-shown',
  ArrowSide = 'data-side',
  ManualFocus = 'data-manual-focused',
}
